// extracted by mini-css-extract-plugin
export default {"error-msg":"InputErrorMessage_error-msg__pcB-n"};